import React from 'react'
import { INFTStakeList } from '../../../models/INFTStake'
import { StakeCard, StakeItem, StakeLogo } from './styled'
import { NavLink, useHistory } from 'react-router-dom'
import {
  useEarnedAmount,
  useNFTStakeRewardRate,
  useNFTStakeTokensOfAccount,
  useNFTStakeTotalStaked
} from '../../../../../hooks/useNFTStake'
import { useActiveWeb3React } from '../../../../../hooks'
import usePrevious from '../../../../../hooks/usePrevious'
import { CountUp } from 'use-count-up'
import Countdown from 'react-countdown'
import NFTButton from '../../../newComponents/NFTButton'
/*@ts-ignore */
import FlipCountdown from '@rumess/react-flip-countdown';

export default function NFTStakeCard({ data }: { data: INFTStakeList }) {
  const { account } = useActiveWeb3React()
  const { collection, maxSupply, earnToken, contractAddress } = data
  const navigator = useHistory();
  const tokensOfAccountList: number[] = useNFTStakeTokensOfAccount(contractAddress, account)
  const totalStakedToken = useNFTStakeTotalStaked(contractAddress)
  const rewardRate = useNFTStakeRewardRate(contractAddress, totalStakedToken, tokensOfAccountList.length)

  const earnedAmount = useEarnedAmount(contractAddress, account)

  const countUpAmount = earnedAmount?.toFixed(6) ?? '0'
  const countUpAmountPrevious = usePrevious(countUpAmount) ?? '0'
  return (
    <StakeItem>
      {data.rewardMultiplier && <div className="rewardMultiplier">{data.rewardMultiplier}x</div>}
      <div className="stakeLogoCounter">
        <StakeLogo>
          <img src={collection.logo} alt={collection.name} />
        </StakeLogo>
      </div>
      <div className="stakeInfo">
        <div className="stakeName">{collection.name}</div>
        <div className="stakedInfoItem">
          <div className="stakedInfoItemText">Total Staked: </div>
          <div className="stakedInfoItemValue">
            {totalStakedToken?.multiply((1000000000000000000).toString())?.toFixed(0, { groupSeparator: ',' }) ?? 0} /{' '}
            {maxSupply}
          </div>
        </div>
        <div className="stakedInfoItem">
          <div className="stakedInfoItemText">Rate: </div>
          <div className="stakedInfoItemValue">
            {rewardRate.totalRewardRate
              ?.multiply((60 * 60 * 24).toString())
              ?.toSignificant(4, { groupSeparator: ',' }) ?? 0}{' '}
            {earnToken.symbol} / day
          </div>
        </div>
        <div className="stakedInfoItem">
          <div className="stakedInfoItemText">Your Rate: </div>
          <div className="stakedInfoItemValue">
            {rewardRate.rewardRate?.multiply((60 * 60 * 24).toString())?.toSignificant(4, { groupSeparator: ',' }) ?? 0}{' '}
            {earnToken.symbol} / day
          </div>
        </div>
        <div className="stakedInfoItem">
          <div className="stakedInfoItemText">Unclaimed: </div>
          <div className="stakedInfoItemValue">
            <CountUp
              key={countUpAmount}
              isCounting
              decimalPlaces={4}
              start={parseFloat(countUpAmountPrevious)}
              end={parseFloat(countUpAmount)}
              thousandsSeparator={','}
              duration={1}
            />{' '}
            {earnToken.symbol}
          </div>
        </div>
      </div>
      <div className="stakeButtons">
        {data.finishAt && (
          <div className="stakeCountdown">
            <FlipCountdown
              hideYear
              hideMonth
              //endAtZero
              size={"extra-small"}
              titlePosition={"bottom"}
              theme={'light'} // Options (Default: dark): dark, light.
              endAt={data.finishAt} // Date/Time
            ><span>Stake Period Finished</span></FlipCountdown>
            {/* <Countdown
              date={data.finishAt}
              renderer={({ days, hours, minutes, seconds }) => {
                if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
                  return 'Stake Period Finished'
                } else {
                  const daysToHour = days * 24 + hours
                  return (
                    <div className="countDown">
                      <div className="countDown">
                        {daysToHour < 10 ? `0${daysToHour}` : daysToHour}:{minutes < 10 ? `0${minutes}` : minutes}:
                        {seconds < 10 ? `0${seconds}` : seconds} left
                      </div>
                    </div>
                  )
                }
              }}
            /> */}
          </div>
        )}
        <NFTButton onClick={() => {
          navigator.push(`/nft-stake/${contractAddress}`);
        }} >Manage</NFTButton>
      </div>
    </StakeItem>
  )
}
